import { Button, Card, Box } from '@deckee/deck-hand';
import React, { FC, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';
// @ts-expect-error -- module cannot be found but it works I swear
import rampGuidanceImage from './assets/ramp-guidance.gif';

const RampGuidancePage: FC = () => {
  const history = useHistory();
  const videoEl = useRef(null);

  const handleNoThanks = () => {
    captureEvent({
      type: 'ramp-guidance: click no thanks',
      payload: {},
    });

    history.push('/maps');
  };

  const handleIWantIt = () => {
    captureEvent({
      type: 'ramp-guidance: click I want it',
      payload: {},
    });
    history.push('/maps/ramp-guidance/subscribe');
  };

  const attemptPlay = () => {
    if (videoEl.current) {
      const videoElement = videoEl.current as HTMLVideoElement;
      videoElement.play();
    }
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <SheetLayout heading="Upcoming feature" showMenuBar={false}>
      <SheetBody>
        <Card>
          <Box w="100%">
            <img src={rampGuidanceImage} width="100%" alt="Ramp Guidance" />
          </Box>
        </Card>
        <Card>
          <Card.Heading size="compact">
            Trailer loading guidance at the ramp
          </Card.Heading>
          <Card.Body>
            Get smart guidance onto your trailer using the camera on your phone.
          </Card.Body>
          <Card.Body>
            <Button.Group wide>
              <Button onClick={handleIWantIt}>I want it</Button>
              <Button onClick={handleNoThanks}>No thanks</Button>
            </Button.Group>
          </Card.Body>
        </Card>
      </SheetBody>
    </SheetLayout>
  );
};

export default RampGuidancePage;
